<template>
  <div class="sh-cart">
    <h3>Ваш заказ:</h3>
    <ul class="sh-cart__items" v-if="items">
      <li class="sh-cart__item uk-flex uk-flex-middle" v-for="item in items" :key="item.id">
        <div class="sh-cart__image">
          <img :src="item.image" alt="">
        </div>
        <div class="sh-cart__title">{{ item.title }}</div>
        <div class="sh-cart__qnt">
          <button type="button" class="js-qnt" @click="changeQnt('minus', item)">-</button>
          <input class="js-inp-qnt" name="qnt" type="text" :value="item.qnt" min="1" onkeyup="this.value=this.value.replace(/[^\d]/,'')">
          <button type="button" class="js-qnt" @click="changeQnt('plus', item)">+</button>
        </div>
        <div class="sh-cart__price"><span class="sh-cart__pre">Цена:</span>{{ item.price }} коинов</div>
        <div class="sh-cart__total"><span class="sh-cart__pre">Сумма:</span>{{ item.price * item.qnt }} коинов</div>
        <div class="sh-cart__delete">
          <a href="#" @click.prevent="removeItem(item)" uk-tooltip="Удалить из корзины"><span uk-icon="close"></span></a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "cart",
  inject: ['http'],
  computed: {
    ...mapGetters({
      user: 'user'
    })
  },
  props: {
    items: ''
  },
  methods: {
    async removeItem(item) {
      let data = {
        'user_id': this.user.id,
        'product_id': item.id
      }
      let res = await this.http.post('onRemoveProductFromCart', data).then(res => res.data);
      let val = {
        'param': 'property',
        'value': res
      }
      this.$store.commit('updateUserParam', val);
    },
    async saveQnt(item){
      let data = {
        'user_id': this.user.id
      }
      let res = await this.http.post('onChangeCartQnt', data).then(res => res.data);
      console.log(res);
    },
    changeQnt(sign, item) {
      if (sign === 'minus') {
        if (item.qnt > 1) {
          item.qnt--;
        }
      } else if (sign === 'plus') {
        item.qnt++;
      }
    },
  }
}
</script>